import React from "react";
import { Check } from "lucide-react";

/**
 * ProgressStepper — multi-step linear progress.
 * steps: [{ id, label }]
 * currentStep: 1-indexed active step
 */
export default function ProgressStepper({ steps = [], currentStep = 1, testId }) {
  return (
    <ol
      data-testid={testId || "progress-stepper"}
      className="flex w-full items-start gap-2 overflow-x-auto"
    >
      {steps.map((step, idx) => {
        const stepNum = idx + 1;
        const state =
          stepNum < currentStep
            ? "completed"
            : stepNum === currentStep
            ? "active"
            : "pending";
        const lineActive = stepNum < currentStep;

        const circleCls =
          state === "completed"
            ? "bg-onedesk-primary text-onedesk-card border-onedesk-primary"
            : state === "active"
            ? "bg-onedesk-card text-onedesk-primary border-onedesk-primary"
            : "bg-onedesk-card text-onedesk-textSecondary border-onedesk-border";

        const labelCls =
          state === "pending"
            ? "text-onedesk-textSecondary"
            : "text-onedesk-textPrimary";

        return (
          <li
            key={step.id || stepNum}
            data-testid={`progress-stepper-step-${stepNum}`}
            className="flex flex-1 items-start gap-2 min-w-[80px]"
          >
            <div className="flex flex-col items-center gap-2 flex-1">
              <div className="flex items-center w-full">
                {/* Left connector */}
                <span
                  className={`h-[2px] flex-1 ${
                    idx === 0
                      ? "bg-transparent"
                      : stepNum <= currentStep
                      ? "bg-onedesk-primary"
                      : "bg-onedesk-border"
                  }`}
                />
                <span
                  className={`flex h-8 w-8 items-center justify-center rounded-full border-2 text-xs font-bold ${circleCls}`}
                  aria-current={state === "active" ? "step" : undefined}
                >
                  {state === "completed" ? (
                    <Check className="h-4 w-4" strokeWidth={3} />
                  ) : (
                    stepNum
                  )}
                </span>
                {/* Right connector */}
                <span
                  className={`h-[2px] flex-1 ${
                    idx === steps.length - 1
                      ? "bg-transparent"
                      : lineActive
                      ? "bg-onedesk-primary"
                      : "bg-onedesk-border"
                  }`}
                />
              </div>
              <span
                className={`text-[11px] font-bold uppercase tracking-wider text-center px-1 ${labelCls}`}
              >
                {step.label}
              </span>
            </div>
          </li>
        );
      })}
    </ol>
  );
}
